export const MOCK_USER = {
  name: "Alex Vance",
  role: "Product Lead",
  // Using a more reliable, professional portrait
  avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150&h=150"
};

export const MOCK_METRICS = {
  totalMeetings: 142,
  hoursSaved: 48.5,
  actionsPending: 24,
  decisionsLogged: 89,
  accuracyRate: "99.2%",
  activeIntegrations: 12
};

export const MOCK_MEETINGS = [
  {
    id: "m-101",
    title: "Q3 Roadmap Alignment",
    date: "2023-10-24T10:00:00Z",
    duration: "45:12",
    status: "processed",
    attendees: [
      { name: "Alex Vance", avatar: "https://ui-avatars.com/api/?name=Alex+Vance&background=2A1B4A&color=00F0FF" },
      { name: "Sarah Chen", avatar: "https://ui-avatars.com/api/?name=Sarah+Chen&background=2A1B4A&color=00F0FF" },
      { name: "Marcus Johnson", avatar: "https://ui-avatars.com/api/?name=Marcus+Johnson&background=2A1B4A&color=00F0FF" }
    ],
    tags: ["Product", "Strategy"],
    summary: "Aligned on Q3 deliverables. Decided to prioritize the new analytics dashboard over the legacy integration. Dev team needs to review API limits.",
    // Specific high-quality tech meeting images
    thumbnail: "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "m-102",
    title: "Client Sync: TechCorp V2",
    date: "2023-10-23T14:30:00Z",
    duration: "58:40",
    status: "processed",
    attendees: [
      { name: "Alex Vance", avatar: "https://ui-avatars.com/api/?name=Alex+Vance&background=2A1B4A&color=00F0FF" },
      { name: "Elena Rodriguez", avatar: "https://ui-avatars.com/api/?name=Elena+Rodriguez&background=2A1B4A&color=00F0FF" }
    ],
    tags: ["Client", "External"],
    summary: "Reviewed TechCorp's feedback on V1. They need 30% faster load times. Agreed to a 2-week optimization sprint starting Monday.",
    thumbnail: "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&q=80&w=800"
  },
  {
    id: "m-103",
    title: "Weekly Engineering Standup",
    date: "2023-10-22T09:00:00Z",
    duration: "15:00",
    status: "processing",
    attendees: [
      { name: "Marcus Johnson", avatar: "https://ui-avatars.com/api/?name=Marcus+Johnson&background=2A1B4A&color=00F0FF" },
      { name: "David Kim", avatar: "https://ui-avatars.com/api/?name=David+Kim&background=2A1B4A&color=00F0FF" }
    ],
    tags: ["Engineering", "Sprint"],
    summary: "Analyzing audio segments and mapping key speakers to identified tasks. Extraction in progress...",
    thumbnail: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800"
  }
];

export const MOCK_TRANSCRIPT = [
  { id: "t1", speaker: "Alex Vance", time: "00:01", text: "Alright, let's get started. The main goal today is locking in the Q3 roadmap.", type: "neutral" },
  { id: "t2", speaker: "Sarah Chen", time: "00:04", text: "I've reviewed the requests. Analytics is requested by 80% of our enterprise tier.", type: "insight" },
  { id: "t3", speaker: "Marcus Johnson", time: "00:08", text: "If we do analytics, we have to push the legacy API integration to Q4. We don't have the bandwidth for both.", type: "warning" },
  { id: "t4", speaker: "Alex Vance", time: "00:15", text: "That makes sense. Let's officially decide to prioritize the analytics dashboard for Q3.", type: "decision" },
  { id: "t5", speaker: "Sarah Chen", time: "00:22", text: "Agreed. Marcus, can your team review the new API rate limits before we build?", type: "action" },
  { id: "t6", speaker: "Marcus Johnson", time: "00:28", text: "Yes, I'll have David draft a quick report on API limits by Friday.", type: "action" },
];

export const MOCK_ACTIONS = [
  { id: "a1", task: "Review new API rate limits", assignee: "Marcus J.", due: "Oct 27", status: "pending", meeting: "Q3 Roadmap Alignment" },
  { id: "a2", task: "Draft report on API limits", assignee: "David K.", due: "Oct 27", status: "pending", meeting: "Q3 Roadmap Alignment" },
  { id: "a3", task: "Send V1 performance report to TechCorp", assignee: "Elena R.", due: "Oct 25", status: "completed", meeting: "Client Sync: TechCorp V2" },
  { id: "a4", task: "Schedule follow-up with design team", assignee: "Alex V.", due: "Oct 28", status: "in-progress", meeting: "Design System Sync" },
  { id: "a5", task: "Update quarterly budget spreadsheet", assignee: "Sarah C.", due: "Oct 30", status: "pending", meeting: "Ops Review" },
];

export const MOCK_DECISIONS = [
  { id: "d1", text: "Prioritize Analytics Dashboard for Q3 over Legacy Integration.", impact: "High", date: "Oct 24", meeting: "Q3 Roadmap Alignment" },
  { id: "d2", text: "Commit to a 2-week performance sprint for TechCorp.", impact: "Med", date: "Oct 23", meeting: "Client Sync: TechCorp V2" },
  { id: "d3", text: "Adopt Tailwind CSS for all new frontend modules.", impact: "Low", date: "Oct 20", meeting: "Frontend Guild" },
  { id: "d4", text: "Increase AWS budget by 15% for scaling analytics.", impact: "High", date: "Oct 19", meeting: "Infra Sync" },
];

export const FAQ_DATA = [
  {
    q: "How does MeetMatrix extract decisions automatically?",
    a: "Our proprietary LLM logic identifies linguistic markers of commitment (e.g., 'We will', 'I decide', 'Let's commit') and cross-references them with the meeting context to log formal decisions."
  },
  {
    q: "Is my meeting data private and secure?",
    a: "Absolutely. MeetMatrix is SOC2 Type II compliant. All audio is processed in transient memory and encrypted at rest using AES-256 bits. We do not use client data for training global models."
  },
  {
    q: "Can I sync actions with Jira or Slack?",
    a: "Yes. Use the 'System Config' to enable two-way sync. Any action item detected will automatically create a ticket in your linked Jira project or post a summary to Slack."
  },
  {
    q: "What is the 'Meeting Command Console'?",
    a: "It is our core interface designed for speed. It allows you to review transcripts while simultaneously verifying AI-extracted tasks, ensuring no human oversight occurs during the automation phase."
  },
  {
    q: "Does it support multi-language meetings?",
    a: "MeetMatrix supports over 32 languages with real-time translation and intelligent summarization, maintaining industry-specific jargon across all supported dialects."
  }
];